export default function changeHashParams({
  state, property, isRemove, payload,
}) {
  if (state.hash.includes(property) && property === "page" && !isRemove) {
    const index = state.hash.indexOf(property);
    let { hash } = state;
    const page = new URLSearchParams(hash.replace("#", "")).get("page");
    let part1 = hash.slice(0, index);
    let part2 = hash.slice(index + 5 + page.length);
    return {
      ...state,
      hash: `${part1}${payload}${part2}`,
    };
  }
  if (state.hash.includes(property) && property === "search" && !isRemove) {
    const index = state.hash.indexOf(property);
    let { hash } = state;
    const search = new URLSearchParams(hash).get("search");
    let part1 = hash.slice(0, index);
    let part2 = hash.slice(index + 7 + search.length);
    return {
      ...state,
      hash: `${part1}${payload}${part2}`,
    };
  }
  if (Array.isArray(property) && state.hash.includes(property[0].split("=")[0]) && !isRemove) {
    return {
      ...state,
      hash: `${payload}`,
    };
  }
  return false;
}
